import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = { class: "alert-heading mb-2" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_9 = { class: "alert-heading mb-2" }
const _hoisted_10 = { class: "mb-0 small" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_13 = { class: "alert-heading mb-2" }
const _hoisted_14 = { class: "mb-0 small" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3 mt-3 fraudex-comments"
}
const _hoisted_16 = { class: "fraudex-comments__title mb-3" }
const _hoisted_17 = { class: "fraudex-comments__list" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "riskConfirmation"
}
const _hoisted_21 = { class: "popup__controls" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    title: _ctx.$t('fraudex.check_result'),
    class: "popup__lg",
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.fraudexCheck)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.fraudexCheck.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("h6", _hoisted_4, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('fraudex.check_error')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.fraudexCheck.error), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.fraudexCheck.isBlacklisted === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h6", _hoisted_9, [
                              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-check-circle me-2" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('fraudex.not_in_blacklist')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_10, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('labels.requisites')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.fraudexCheck.requisite), 1)
                            ])
                          ])
                        ]))
                      : (_ctx.fraudexCheck.isBlacklisted === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("h6", _hoisted_13, [
                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('fraudex.in_blacklist')), 1)
                              ]),
                              _createElementVNode("p", _hoisted_14, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('labels.requisites')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.fraudexCheck.requisite), 1)
                              ])
                            ]),
                            (_ctx.fraudexCheck.comments && _ctx.fraudexCheck.comments.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.$t('fraudex.comments')) + ":", 1),
                                  _createElementVNode("ul", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fraudexCheck.comments, (comment, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "fraudex-comments__item"
                                      }, _toDisplayString(comment), 1))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.riskConfirmed) = $event)),
                                  id: "riskConfirmation"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.riskConfirmed]
                                ]),
                                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('fraudex.confirm_risks')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
          class: "btn popup__close"
        }, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('button.cancel')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleContinue && _ctx.handleContinue(...args))),
          disabled: _ctx.fraudexCheck && !_ctx.fraudexCheck.error && _ctx.fraudexCheck.isBlacklisted === true && !_ctx.riskConfirmed,
          class: "btn btn--accept"
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-check me-2" }, null, -1)),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('button.continue')), 1)
        ], 8, _hoisted_23)
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}